document.addEventListener('DOMContentLoaded', function () {
  /* Nav mobile */
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* Root-divider draw-on-scroll */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dividers = document.querySelectorAll('.root-divider');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    dividers.forEach(function (el) { io.observe(el); });
  } else {
    dividers.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Simple gallery lightbox */
  var galleryItems = document.querySelectorAll('[data-lightbox-src]');
  if (galleryItems.length) {
    var overlay = document.createElement('div');
    overlay.className = 'lightbox-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(20,18,15,.92);display:none;align-items:center;justify-content:center;z-index:200;padding:24px;';
    var img = document.createElement('img');
    img.style.cssText = 'max-width:90vw;max-height:88vh;border:1.5px solid #EFE7D6;';
    var closeBtn = document.createElement('button');
    closeBtn.className = 'lightbox-close';
    closeBtn.setAttribute('aria-label', 'Fermer');
    closeBtn.textContent = '\u2715';
    overlay.appendChild(img);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);

    function close() { overlay.style.display = 'none'; }
    overlay.addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    galleryItems.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        img.src = el.getAttribute('data-lightbox-src');
        img.alt = el.getAttribute('data-lightbox-alt') || '';
        overlay.style.display = 'flex';
      });
    });
  }
});


/* Vignettes de la page produit */
document.addEventListener('click', function (e) {
  var thumb = e.target.closest('.product-thumbs__item');
  if (!thumb) return;
  var main = document.getElementById('ProductMainImage');
  if (main && thumb.getAttribute('data-full')) {
    main.src = thumb.getAttribute('data-full');
  }
});
